// What a signed-out browser keeps (PROTOCOL.md §3): only how it looks. Everything else the app left in localStorage —
// carets, last pages, filters, sprints, per-project settings keyed by project id, the account's name — goes, as the vault
// key and the offline copies do.

/** The keys that stay: the browser's look, not anything about an account or its projects. */
const KEEP = new Set(['ws:appearance', 'ws:contrast', 'ws:showsFormattingMarks']);

/** Removes every localStorage key but `KEEP`. Never throws (storage may be blocked). */
export function forgetLocalPreferences(): void {
  try {
    const keys: string[] = [];
    for (let i = 0; i < localStorage.length; i++) {
      const k = localStorage.key(i);
      if (k !== null && !KEEP.has(k)) keys.push(k);
    }
    for (const k of keys) localStorage.removeItem(k);
  } catch {
    // nothing kept, or nothing reachable
  }
}

/**
 * Deletes the web app's offline database (the sealed copies, outbox and project titles), for a sign-out from the account
 * page, where the app's own store isn't open to wipe. A tab of the app still open holds it until that tab closes or
 * signs out itself; nothing waits for that.
 */
export function forgetAppDatabase(name = 'writing-suite-app'): void {
  try {
    if (typeof indexedDB !== 'undefined') indexedDB.deleteDatabase(name);
  } catch {
    // unavailable
  }
}
